import { Controller } from "@hotwired/stimulus"

// Copy-to-clipboard for a value that has to be transcribed exactly — a domain
// verification token, a pairing code. These were rendered as wrapping text with
// no way to take a copy, and a token that wraps mid-string is a token somebody
// retypes wrong.
export default class extends Controller {
  static values = { text: String }

  static targets = ["label"]

  static RESET_AFTER = 2000

  // The swapped label is the only confirmation a press produces — nothing else
  // on the page moves — and changing text inside an ordinary element announces
  // nothing. Made a live region here rather than written into each of the four
  // buttons that use this, so a fifth is not silent again, and silently so.
  //
  // Polite, and set before anything changes: a live region reads what moves
  // inside it rather than what it already says, so arriving as "Copy"
  // announces nothing until it becomes "Copied".
  connect() {
    if (this.hasLabelTarget) this.labelTarget.setAttribute("aria-live", "polite")
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.textValue)
      this.say("Copied")
    } catch {
      // Denied outright in some contexts. Saying nothing reads as a dead
      // button, and the value is selectable either way.
      this.say("Press ⌘C")
    }
  }

  say(message) {
    if (!this.hasLabelTarget) return

    const original = this.original ??= this.labelTarget.textContent
    this.labelTarget.textContent = message
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => { this.labelTarget.textContent = original }, this.constructor.RESET_AFTER)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
